import { Injectable, Inject } from '@angular/core';
import { WA_WINDOW } from '@ng-web-apis/common';
import { NutrientViewerLicenseKey } from './nutrient-viewer-license';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NutrientViewerLicenseService {
  // NOTE: this identifier may change when Nutrient releases a major update
  public static identifier = 'PS260118-55454-94036';

  constructor(
    private http: HttpClient,
    @Inject(WA_WINDOW) private window: Window
  ) {}

  public getLicenseKey() {
    return this.http
      .get<NutrientViewerLicenseKey[]>(
        '/assets/nutrient-viewer-license-keys.json'
      )
      .pipe(
        map((bundle) =>
          bundle.find(
            ({ identifier }) =>
              identifier === NutrientViewerLicenseService.identifier
          )
        ),
        map(({ bundle_ids }) =>
          bundle_ids.find(
            ({ bundle_id }) => bundle_id === this.window.location.hostname
          )
        ),
        map(({ license_key }) => license_key)
      );
  }
}
